/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import Img from 'react-cool-img'
import { Text } from 'hocs/localization'
import HomeLayout from 'apps/HomeLayout'
import Button from 'elements/Button'
import * as styles from './ContactUs.scss'
import loadingImage from './assets/contact-us-header-min.jpg'
import headerImgSrc from './assets/contact-us-header.jpg'

const cx = classNames.bind(styles)

interface IProps {
  t: Text,
  generalContact: any,
}

const ContactUs: React.FC<IProps> = ({ t, generalContact }) => (
  <HomeLayout>
    <div className={styles.contactSection}>
      <div className={styles.contactsHeader}>
        <Img
          placeholder={loadingImage}
          src={headerImgSrc}
        />
      </div>
      <div className={styles.contactTitle}>
        <span>Contact Us</span>
      </div>
    </div>

    <section className={styles.contactPage}>
      <div className={styles.contactDetail}>
        <div className={cx('container', styles.container768)}>
          <div className='row'>
            <div className='col-md-6'>
              <ul className={styles.emailSupport}>
                <li className={styles.title}>{t('emailSupport')}</li>
                <li>
                  <Button
                    styleType='primary'
                    type='link'
                    href={t('link')}
                    target='_blank'
                    isExternalLink
                  >
                    {t('emailButton')}
                  </Button>
                </li>
              </ul>
            </div>
            <div className='col-md-6'>
              <ul className={cx(styles.emailSupport, styles.phoneSupport)}>
                <li className={styles.title}>{t('phoneSupport')}</li>
                <li>
                  <a href={`tel:${generalContact.phoneNumber}`}>
                    {generalContact.phoneNumber}
                  </a>
                </li>
                <li className={styles.title}>{t('supportHours')}</li>
                <li>
                  <p>{t('supportHoursContent1')}</p>
                  <p>{t('supportHoursContent2')}</p>
                </li>
              </ul>
            </div>
          </div>
            <hr/>
            <div className={styles.faqInfo}>
              <ul className={styles.faqInfo}>
                <li className={styles.faqHeader}>{t('faqHeader')}</li>
                <li className={styles.faqQuestion}>{t('faqQuestion1')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer1')} </li>
                <li className={styles.faqQuestion}>{t('faqQuestion2')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer2')}</li>
                <li className={styles.faqQuestion}>{t('faqQuestion3')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer3')}</li>
                <li className={styles.faqQuestion}>{t('faqQuestion4')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer4')} </li>
                <li className={styles.faqQuestion}>{t('faqQuestion5')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer5')}</li>
                <li className={styles.faqQuestion}>{t('faqQuestion6')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer6')}</li>
                <li className={styles.faqQuestion}>{t('faqQuestion7')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer7')} </li>
                <li className={styles.faqQuestion}>{t('faqQuestion8')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer8a')} <br/><br/>{t('faqAnswer8b')}</li>
                <li className={styles.faqQuestion}>{t('faqQuestion9')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer9')}</li>
                <li className={styles.faqQuestion}>{t('faqQuestion10')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer10')}</li>
                <li className={styles.faqQuestion}>{t('faqQuestion11')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer11')}</li>
                <li className={styles.faqQuestion}>{t('faqQuestion12')}</li>
                <li className={styles.faqAnswer}>{t('faqAnswer12a')} <br/><br/>{t('faqAnswer12b')}<br/><br/>{t('faqAnswer12c')}</li>
              </ul>
            </div>
        </div>
      </div>
    </section>
  </HomeLayout>
)

export default ContactUs
